var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.875,
    height: 24.875,
    viewBox: "0 0 24.875 24.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104348",
    "data-name": "Path 104348",
    d: "M21.659,20.307l-3.151-3.151L21.659,14a.956.956,0,1,0-1.351-1.351L17.156,15.8l-3.151-3.151A.956.956,0,0,0,12.654,14L15.8,17.155l-3.151,3.151a.924.924,0,0,0,0,1.351.949.949,0,0,0,1.351,0l3.151-3.151,3.151,3.151a.96.96,0,0,0,1.351,0A.949.949,0,0,0,21.659,20.307Z",
    transform: "translate(-1.344 -1.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104349",
    "data-name": "Path 104349",
    d: "M15.812,5.049A10.759,10.759,0,1,1,8.2,8.2a10.692,10.692,0,0,1,7.612-3.151m0-1.674A12.437,12.437,0,1,0,28.25,15.812,12.435,12.435,0,0,0,15.812,3.375Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5ad4824c7208be53173f9ce1c62c5c16.svg";
export { ForwardRef as ReactComponent };